import type { Node } from '@craftjs/core';
import {
  FormTextField as SharedFormTextField,
  type FormTextFieldProps,
  formTextFieldDefaultProps,
} from '@builder4/shared/components/Form';
import { FORM_TEXT_FIELD_NODE_NAME } from '@/utils/constants';
import { InspectorForm } from '@/components/inspector/InspectorForm/InspectorForm';

type NodeQueryHelper = (id: string) => {
  get(): Node | null;
  childNodes(): string[];
};

const EditorFormTextField = (props: Partial<FormTextFieldProps>) => {
  return <SharedFormTextField {...props} />;
};

EditorFormTextField.craft = {
  ...SharedFormTextField.craft,
  displayName: FORM_TEXT_FIELD_NODE_NAME,
  props: formTextFieldDefaultProps,
  related: {
    toolbar: InspectorForm,
  },
  rules: {
    canDrag: (node: Node, helpers: NodeQueryHelper) => {
      if (node.data.custom?.isLocked) {
        return false;
      }
      const parentId = node.data.parent;
      if (!parentId) return false;
      const parent = helpers(parentId).get();
      if (!parent) return false;
      const siblingFieldIds = parent.data.nodes.filter((childId: string) => {
        const child = helpers(childId).get();
        return child?.data.displayName === FORM_TEXT_FIELD_NODE_NAME;
      });
      return siblingFieldIds.length > 1;
    },
    canMoveOut: (outgoingNodes: Node[], self: Node, helpers: NodeQueryHelper) => {
      const parentId = self.data.parent;
      if (!parentId) return false;
      const parent = helpers(parentId).get();
      if (!parent) return false;
      const fieldIds = parent.data.nodes.filter((childId: string) => {
        const child = helpers(childId).get();
        return child?.data.displayName === FORM_TEXT_FIELD_NODE_NAME;
      });
      const movingIds = new Set(outgoingNodes.map((n) => n.id));
      const remaining = fieldIds.filter((fieldId: string) => !movingIds.has(fieldId));
      return remaining.length >= 1;
    },
    canMoveIn: () => false,
  },
};

export default EditorFormTextField;
